import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Tooltip, Space, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import { Application } from "@yulintu/freesia-bootstrap";

import useDesigner from "../hooks/useDesigner";
import useDesignerMessage from "../hooks/useDesignerMessage";

export default function Addon(props) {

    return <>
        <Tooltip title="导出" placement="bottom">
            <Button
                {...props}
                icon={<Application.SystemSvgIcon type="xiazai" style={{ fontSize: 20, marginRight: 7, color: "#888888" }} />}
            >
                <Space style={{ fontSize: 15 }} size={6}>
                    导出
                    <DownOutlined style={{ fontSize: 12, color: "#ababab" }} />
                </Space>
            </Button>
        </Tooltip>
    </>
}